import { useEffect, useState } from 'react';
import { api } from '@/lib/api-client';

export type AuthedBlobUrl = {
  url: string | null;
  isLoading: boolean;
  isError: boolean;
};

const API_PREFIX = '/api';

function toApiClientPath(downloadUrl: string): string {
  return downloadUrl.startsWith(API_PREFIX)
    ? downloadUrl.slice(API_PREFIX.length)
    : downloadUrl;
}

export function useAuthedBlobUrl(path: string | null): AuthedBlobUrl {
  const [url, setUrl] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (path === null) {
      setUrl(null);
      setIsLoading(false);
      setIsError(false);
      return;
    }

    let cancelled = false;
    let objectUrl: string | null = null;
    setIsLoading(true);
    setIsError(false);

    api
      .fetchBlob(toApiClientPath(path))
      .then((blob) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setUrl(objectUrl);
        setIsLoading(false);
      })
      .catch(() => {
        if (cancelled) return;
        setIsError(true);
        setUrl(null);
        setIsLoading(false);
      });

    return () => {
      cancelled = true;
      if (objectUrl !== null) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [path]);

  return { url, isLoading, isError };
}
